/** Tab-local recovery is scoped to the authenticated administrator and operation. */
export function readManagedRequest<T>(key: string): T | null {
  try {
    return JSON.parse(sessionStorage.getItem(`bilt-managed-request:${key}`) || 'null');
  } catch {
    return null;
  }
}

export function storeManagedRequest<T>(key: string, value: T | null): void {
  try {
    if (value == null) sessionStorage.removeItem(`bilt-managed-request:${key}`);
    else sessionStorage.setItem(`bilt-managed-request:${key}`, JSON.stringify(value));
  } catch {
    /* The in-memory request remains available when storage is unavailable. */
  }
}

export function managedRequestId(): string {
  if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  return Array.from(crypto.getRandomValues(new Uint8Array(24)), (n) =>
    n.toString(16).padStart(2, '0')
  ).join('');
}

/** Network/server uncertainty keeps the exact request. A rejected input can be corrected. */
export function managedRequestRejected(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false;
  const value = error as { status?: number; code?: string };
  if (value.code === 'invalid_input' || value.code === 'managed_builder_conflict') return true;
  return Boolean(
    value.status &&
    value.status >= 400 &&
    value.status < 500 &&
    ![408, 429].includes(value.status) &&
    !String(value.code || '').includes('request_conflict')
  );
}

export function managedRequestMessage(error: unknown): string {
  return error instanceof Error ? error.message : 'Could not save. Please try again.';
}
